const { getElement } = window.BAO.Utils
class RechargeSubscription extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.BAO.Utils.waitForGlobal('ReChargeWidget', () => {
      const config = {
        productId: this.productId, // Required
        injectionParent: this, // The node that will have the widget injected in
        injectionMethod: 'prepend', // How will the widget be injected
        selectors: {
          variant: ['.prd-DetailVariants_Select'], // The variants to watch for to update the subscription prices
        },
      }

      const rechargeWidget = window.ReChargeWidget.createWidget(config);

      const rechargeWidgetLoadedEvent = new CustomEvent("rechargeWidgetLoadedEvent", {
        detail: {
          widget: rechargeWidget
        }
      });
      document.dispatchEvent(rechargeWidgetLoadedEvent);
      
    })
  }

  get productId () {
    return parseInt(this.dataset.productId)
  }
}

if (!customElements.get('recharge-subscription')) {
  customElements.define('recharge-subscription', RechargeSubscription)
}

let rechargeRecommendedLoaded = false

class RechargeProductsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    if (rechargeRecommendedLoaded) return

    window.BAO.sectionRenderer
      .fetch('recharge-products-carousel', '/?view=recharge-products-carousel')
      .then(res => {
        rechargeRecommendedLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.localName],
        )
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }
}

if (!customElements.get('recharge-products-carousel')) {
  customElements.define('recharge-products-carousel', RechargeProductsCarousel)
}

let rechargeTextMediaLoaded = false

class RechargeTextMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    if (rechargeTextMediaLoaded) return

    window.BAO.sectionRenderer
      .fetch('recharge-text-media', '/?view=recharge-text-media')
      .then(res => {
        rechargeTextMediaLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.localName],
        )
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }
}

if (!customElements.get('recharge-text-media')) {
  customElements.define('recharge-text-media', RechargeTextMedia)
}

;(() => {
  const openReferAFriend = e => {
    const target = e.target
    if (target.getAttribute('data-lion-faux-refer') === null) return

    e.preventDefault()

    getElement('[data-lion-refer]').click()
  }

  window.addEventListener('click', openReferAFriend)
})()
